import React, { useEffect, useContext } from "react";
import useForm from "../../../../services/UseForm";
import validate from '../../../../validations/admin/product/productTypeValidate';
import '../../../../css/popUpForm.css';
import axios from "axios";
import { API } from "../../../../services/api";
import { ProductTypeContext } from "../productType";

axios.defaults.baseURL = API;

function UpdateProductType(props) {

    const {dataList, setDataList, data} = useContext(ProductTypeContext);

    const handleInputStatusChange = event => {
        const { name, value } = event.target;
        handleChange(name, value)
        check(value);
    };

    const check = (params) => {
        const results = dataList.filter((data) => {
            return data.ProductType.toLowerCase() === params.toLowerCase()
        });
        if (results.length > 0)
            handleChange("CheckProductType", results[0].ProductType);
        else
            handleChange("CheckProductType", "");
    }

    async function update() {
        let token = localStorage.getItem("token");
        var data = {
            ProductType: values.ProductType
        }
        await axios.put(`/updateProductType/${values.ProductTypeID}`, data, { headers: { Authorization: `MR_ADMIN ${token}`}}).then((response) => {

            for (var i=0; i < dataList.length; i++) {
                if (dataList[i].ProductTypeID == values.ProductTypeID) {
                    dataList[i].ProductType = values.ProductType;
                    localStorage.setItem("ProductTypeData", JSON.stringify(dataList));
                    break;
                }
            }  
            setDataList(dataList);
            ClearData();
            props.onClick(false);
        }).catch((err) => {
            console.log(err);
        });
    };

    const ClearData = () => {
        handleChange("ProductTypeID", "");
        handleChange("ProductType", "");
    }

    const {
        values,
        errors,
        handleChange,
        handleSubmit,
    } = useForm(update, validate);

    useEffect(() => {
        data.forEach(value => {
            handleChange("ProductTypeID", value.ProductTypeID);
            handleChange("ProductType", value.ProductType);
            handleChange("CheckProductType", "");
        });
    }, [data]);

    return (
        <div style={{ display: props && props.show ? 'flex' : 'none' }} className="popUpForm">
            <div className="content">
                <div className="Header">
                    <span>ແກ້ໄຂປະເພດສິນຄ້າ</span>
                </div>
                <div className="Body">
                    <form onSubmit={handleSubmit} noValidate>
                        <div className="form-row">
                            <div className="col form-group">
                                <span>ປະເພດຈ່າຍ</span>
                                <input className={`input form-control ${errors.ProductType && 'is-invalid'}`} type="text" name="ProductType" onChange={(e) => handleInputStatusChange(e)} value={values.ProductType || ''} required />
                                {errors.ProductType && (
                                    <p className="invalid-feedback">{errors.ProductType}</p>
                                )}
                            </div>
                        </div>
                        <div className="footer">
                            <button type="submit" className="btn btn-primary">
                                ບັນທຶກ
                            </button>
                            <button type="button" onClick={(e) => props.onClick(false)} className="btn btn-danger" data-dismiss="modal" aria-label="Close">
                                ກັບຄືນ
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default UpdateProductType;
